import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@material-ui/core";
import { Close, Delete, Edit } from "@material-ui/icons";
import parsePhoneNumber from "libphonenumber-js";
import React, { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Modal from "../../components/Modal/Modal";
import _ from "underscore";
import {
    geocodeResponseToCityState,
    IsNullOrEmpty,
    validEmail,
    validPhone,
} from "../../helpers/utility";
import {
    createDeliveryAddressRequest,
    deleteDeliveryAddressRequest,
    getDeliveryAddressRequest,
    updateDeliveryAddressRequest,
} from "../../store/user/deliveryaddress/deliveryaddress.actions";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
var api_key = process.env.REACT_APP_GOOGLE_API_KEY;

const Address = () => {
    const history = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [state, setCurState] = useState("");
    const [nickName, setNickName] = useState("");
    const [address, setAddress] = useState("");
    const [address1, setAddress1] = useState("");
    const [city, setCity] = useState("");
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [postCode, setPostCode] = useState("");
    const [isDefault, setIsDefault] = useState(true);
    const [isSeller, setIsSeller] = useState(true);
    const [status, setStatus] = useState("Active");
    const [showModal, setShowModal] = useState(false);
    const [mode, setMode] = useState("");
    const [id, setId] = useState("");
    const [selected, setSelected] = useState("MY");
    const [countryCode, setCountry] = useState("+60");
    const [form, setForm] = useState(false);

    const { deliveryAddresses } = useSelector((state) => {
        return {
            deliveryAddresses: getDeliveryAddresses(state),
        };
    });

    const isSellerExist = deliveryAddresses.filter((x) => {
        return x.isSeller === true;
    });

    const isDefaultExist = deliveryAddresses.filter((x) => {
        return x.isDefault === true;
    });

    const validate = () => {
        return (
            !IsNullOrEmpty(name) &&
            !IsNullOrEmpty(address) &&
            !IsNullOrEmpty(address1) &&
            !IsNullOrEmpty(city) &&
            !IsNullOrEmpty(state) &&
            !IsNullOrEmpty(postCode) &&
            !IsNullOrEmpty(phone) &&
            !IsNullOrEmpty(email)
        );
    };

    useEffect(() => {
        dispatch(getDeliveryAddressRequest());
    }, []);

    useEffect(() => {
        setName("");
        setPhone("");
        setAddress("");
        setAddress1("");
        setCity("");
        setPostCode("");
        setIsDefault(false);
        setIsSeller(false);
        setStatus("Active");
        setMode("");
        setId("");
        setShowModal(false);
        if (deliveryAddresses.length > 0) {
            setMode("");
            setShowModal(false);
        } else if (
            location &&
            location.state &&
            location.state.mode &&
            location.state.mode === "add"
        ) {
            setMode("add");
            setShowModal(true);
        }
    }, [deliveryAddresses, location]);

    const handleSave = () => {
        if (validate()) {
            let data = {
                name: name,
                phone: countryCode + phone,
                address: address,
                subAddress: address1,
                city: city,
                isDefault: isDefaultExist.length === 0 ? true : isDefault,
                isSeller: isSellerExist.length === 0 ? true : isSeller,
                postCode: postCode,
                status: status,
                state: state,
                country: countryCode,
                nickName: IsNullOrEmpty(nickName) ? name : nickName,
                email: email,
            };

            if (mode === "Edit") {
                data._id = id;
                dispatch(updateDeliveryAddressRequest(data, history));
            } else {
                dispatch(createDeliveryAddressRequest(data, history));
            }
        } else {
            setForm(true);
        }
    };

    const getCountryByCode = (code) => {
        if (code == "+65") return "SG";
        if (code == "+60") return "MY";
        if (code == "+1") return "US";
    };

    const handleSelect = (code) => {
        setSelected(code);
        if (code === "SG") setCountry("+65");
        if (code === "MY") setCountry("+60");
        if (code === "US") setCountry("+1");
    };

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-7">
                {deliveryAddresses.map((x) => {
                    return (
                        <div className="rounded-10 border border-black-10">
                            <div className="py-[11px] text-center border-b border-black-10">
                                <h4 className="text-base font-bold text-[#2B1C50]">
                                    {x.nickName} Address
                                </h4>
                            </div>

                            <div className="px-3 py-4 sm:p-5">
                                <div className="flex flex-col space-y-3 mb-5">
                                    <div className="text-black-60 text-sm font-medium flex items-center gap-x-4">
                                        <span>
                                            <svg
                                                width="14"
                                                height="16"
                                                className="stroke-current"
                                                viewBox="0 0 14 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M7.0013 7.99967C8.84225 7.99967 10.3346 6.50729 10.3346 4.66634C10.3346 2.82539 8.84225 1.33301 7.0013 1.33301C5.16035 1.33301 3.66797 2.82539 3.66797 4.66634C3.66797 6.50729 5.16035 7.99967 7.0013 7.99967Z"
                                                    strokeWidth="2"
                                                />
                                                <path
                                                    d="M10.334 9.33301H10.5687C11.0561 9.33315 11.5266 9.51125 11.892 9.83386C12.2573 10.1565 12.4923 10.6014 12.5527 11.085L12.8134 13.1677C12.8368 13.3553 12.8201 13.5458 12.7643 13.7264C12.7085 13.9071 12.6149 14.0738 12.4898 14.2155C12.3646 14.3573 12.2108 14.4708 12.0384 14.5485C11.866 14.6262 11.6791 14.6664 11.49 14.6663H2.51136C2.32228 14.6664 2.13535 14.6262 1.96299 14.5485C1.79062 14.4708 1.63676 14.3573 1.51161 14.2155C1.38646 14.0738 1.29288 13.9071 1.23709 13.7264C1.18131 13.5458 1.16458 13.3553 1.18802 13.1677L1.44802 11.085C1.50849 10.6012 1.74364 10.1561 2.10925 9.83342C2.47486 9.51078 2.94574 9.33282 3.43336 9.33301H3.66736"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <p>{x.name}</p>
                                    </div>

                                    <div className="text-black-60 text-sm font-medium flex gap-x-4">
                                        <span>
                                            <svg
                                                width="14"
                                                height="16"
                                                className="stroke-current"
                                                viewBox="0 0 14 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M7 8.66602C8.10457 8.66602 9 7.77059 9 6.66602C9 5.56145 8.10457 4.66602 7 4.66602C5.89543 4.66602 5 5.56145 5 6.66602C5 7.77059 5.89543 8.66602 7 8.66602Z"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M6.99935 1.33301C5.58486 1.33301 4.22831 1.89491 3.22811 2.89511C2.22792 3.8953 1.66602 5.25185 1.66602 6.66634C1.66602 7.92767 1.93402 8.75301 2.66602 9.66634L6.99935 14.6663L11.3327 9.66634C12.0647 8.75301 12.3327 7.92767 12.3327 6.66634C12.3327 5.25185 11.7708 3.8953 10.7706 2.89511C9.77039 1.89491 8.41384 1.33301 6.99935 1.33301V1.33301Z"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <p>
                                            {x.address}, {x.subAddress},{" "}
                                            {x.city} - {x.postCode},<br />
                                            {x.state},<br />
                                            {x.country === "+60"
                                                ? "Malaysia"
                                                : x.country === "+1"
                                                ? "United States"
                                                : "Singapore"}
                                            ,
                                            <br />
                                        </p>
                                    </div>
                                    <div className="text-black-60 text-sm font-medium flex items-center gap-x-4">
                                        <span>
                                            <svg
                                                width="16"
                                                height="16"
                                                className="stroke-current"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M7.03485 4.16035L4.77952 1.55701C4.51952 1.25701 4.04285 1.25835 3.74085 1.56101L1.88619 3.41901C1.33419 3.97168 1.17619 4.79235 1.49552 5.45035C3.40326 9.40032 6.58888 12.5904 10.5362 14.5037C11.1935 14.823 12.0135 14.665 12.5655 14.1123L14.4375 12.237C14.7409 11.9337 14.7415 11.4543 14.4389 11.1943L11.8255 8.95101C11.5522 8.71634 11.1275 8.74701 10.8535 9.02168L9.94419 9.93235C9.89763 9.98114 9.83635 10.0133 9.76975 10.0239C9.70315 10.0345 9.63492 10.0229 9.57552 9.99101C8.08915 9.13508 6.85618 7.9005 6.00219 6.41301C5.9702 6.35351 5.95862 6.28516 5.96922 6.21845C5.97982 6.15174 6.01201 6.09034 6.06085 6.04368L6.96752 5.13635C7.24219 4.86035 7.27219 4.43435 7.03485 4.16035Z"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <p>{x.phone}</p>
                                    </div>
                                    <div className="text-black-60 text-sm font-medium flex items-center gap-x-4">
                                        <span>
                                            <svg
                                                width="16"
                                                height="12"
                                                className="stroke-current"
                                                viewBox="0 0 16 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1 1L8 6L15 1M1 11H15V1H1V11Z"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <p>{x.email}</p>
                                    </div>
                                </div>

                                <div className=" text-sm text-black-60 mb-3.5">
                                    <input
                                        checked={x.isDefault}
                                        type="radio"
                                        id="account-radio-one"
                                        className="hidden"
                                    />
                                    <input
                                        checked={x.isSeller}
                                        type="radio"
                                        id="account-radio-two"
                                        className="hidden"
                                    />

                                    <label
                                        for="account-radio-one"
                                        className="flex items-center mb-2.5 cursor-pointer"
                                    >
                                        <span className="w-4 h-4 rounded-full mr-3 account-radio-one border border-[#D1D5DB]"></span>
                                        <span className="cursor-pointer inline-block">
                                            Make as default receiver address
                                        </span>
                                    </label>
                                    <label
                                        for="account-radio-two"
                                        className="flex items-center cursor-pointer"
                                    >
                                        <span className="w-4 h-4 rounded-full mr-3 account-radio-two border border-[#D1D5DB]"></span>
                                        <span className="cursor-pointer whitespace-nowrap w-full sm:w-fit inline-block">
                                            Make as default sender address
                                        </span>
                                    </label>
                                </div>

                                <div className="flex items-center space-x-2">
                                    <button
                                        onClick={() => {
                                            setName(x.name);
                                            setPhone(x.phone);
                                            setAddress(x.address);
                                            setAddress1(x.subAddress);
                                            setCities([x.city]);
                                            setStates([x.state]);
                                            setCity(x.city);
                                            setPostCode(x.postCode);
                                            setIsDefault(x.isDefault);
                                            setIsSeller(x.isSeller);
                                            setStatus(x.status);
                                            setMode("Edit");
                                            setId(x._id);

                                            setEmail(x.email);
                                            setNickName(x.nickName);
                                            setCurState(x.state);

                                            setShowModal(true);
                                            const phoneNumber =
                                                parsePhoneNumber(x.phone, "MY");
                                            if (phoneNumber) {
                                                setPhone(
                                                    phoneNumber.nationalNumber
                                                );
                                                setCountry(
                                                    "+" +
                                                        phoneNumber.countryCallingCode
                                                );
                                                if (
                                                    phoneNumber.countryCallingCode ===
                                                    "1"
                                                )
                                                    setSelected("US");
                                                if (
                                                    phoneNumber.countryCallingCode ===
                                                    "65"
                                                )
                                                    setSelected("SG");
                                                if (
                                                    phoneNumber.countryCallingCode ===
                                                    "60"
                                                )
                                                    setSelected("MY");
                                            }
                                        }}
                                        className="py-[7px] w-full rounded-lg text-sm font-bold text-white flex items-center justify-center border border-orange-color bg-orange-color capitalize"
                                    >
                                        <span>
                                            <svg
                                                width="15"
                                                height="15"
                                                className="stroke-current text-white mr-2"
                                                viewBox="0 0 15 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.75 2.25H3C2.17157 2.25 1.5 2.92158 1.5 3.75V12C1.5 12.8284 2.17157 13.5 3 13.5H11.25C12.0784 13.5 12.75 12.8284 12.75 12V8.25M11.6893 1.18934C12.2751 0.603553 13.2249 0.603553 13.8107 1.18934C14.3964 1.77513 14.3964 2.72487 13.8107 3.31066L7.37132 9.75H5.25L5.25 7.62868L11.6893 1.18934Z"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <span>Edit</span>
                                    </button>
                                    <button
                                        onClick={() => {
                                            Swal.fire({
                                                title: "Confirm delete?",
                                                text: "A deleted address cannot be restored later.",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "red",
                                                cancelButtonColor: "white",
                                                cancelButtonText: "Cancel",
                                                confirmButtonText: "Delete",
                                                customClass: {
                                                    cancelButton:
                                                        "order-1 right-gap",
                                                    confirmButton: "order-2",
                                                    denyButton: "order-3",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    dispatch(
                                                        deleteDeliveryAddressRequest(
                                                            x._id
                                                        )
                                                    );
                                                }
                                            });
                                        }}
                                        className="py-[7px] w-full rounded-lg text-sm font-medium text-black-50 flex items-center justify-center border border-black-10 bg-white capitalize"
                                    >
                                        <span>
                                            <svg
                                                width="15"
                                                height="15"
                                                className="stroke-current mr-2"
                                                viewBox="0 0 15 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M12.75 3.75L12.0995 12.8569C12.0434 13.6418 11.3903 14.25 10.6033 14.25H4.39668C3.60972 14.25 2.95656 13.6418 2.90049 12.8569L2.25 3.75M6 6.75V11.25M9 6.75V11.25M9.75 3.75V1.5C9.75 1.08579 9.41421 0.75 9 0.75H6C5.58579 0.75 5.25 1.08579 5.25 1.5V3.75M1.5 3.75H13.5"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <span>Delete</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="flex justify-start">
                <button
                    onClick={() => {
                        setMode("add");
                        setShowModal(true);
                        setName("");
                        setPhone("");
                        setAddress("");
                        setAddress1("");
                        setCities([]);
                        setStates([]);
                        setCity("");
                        setPostCode("");
                        setIsDefault(false);
                        setIsSeller(false);
                        setStatus("Active");
                        setId("");

                        setEmail("");
                        setNickName("");
                        setCurState("");
                    }}
                    className="py-2.5 px-5 text-sm bg-orange-color font-bold text-white rounded-lg border border-orange-color capitalize"
                >
                    Add New Address
                </button>
            </div>

            <Dialog open={showModal} onClose={() => setShowModal(false)}>
                <DialogTitle>
                    {mode === "add" ? "Add New Address" : "Update Address"}

                    <Close
                        className="float-right"
                        onClick={() => setShowModal(false)}
                    />
                </DialogTitle>
                <DialogContent>
                    <Container maxWidth="sm">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    placeholder="Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    variant="outlined"
                                    color="primary"
                                    error={form && IsNullOrEmpty(name)}
                                    helperText={
                                        form && IsNullOrEmpty(name)
                                            ? "Name is required"
                                            : ""
                                    }
                                    className="mb-4"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    variant="outlined"
                                    className="mb-4"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ReactFlagsSelect
                                                    className="react-select"
                                                    selected={selected}
                                                    onSelect={(code) =>
                                                        handleSelect(code)
                                                    }
                                                    countries={[
                                                        "MY",
                                                        "SG",
                                                        "US",
                                                    ]}
                                                    customLabels={{
                                                        MY: "Malaysia +60",
                                                        SG: "Singapore +65",
                                                        US: "United States +1",
                                                    }}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                    fullWidth
                                    helperText={
                                        form &&
                                        (IsNullOrEmpty(phone) ||
                                            !validPhone(phone))
                                            ? "Phone Should be valid and not empty"
                                            : ""
                                    }
                                    error={
                                        form &&
                                        (IsNullOrEmpty(phone) ||
                                            !validPhone(phone))
                                    }
                                    label="Phone number"
                                    placeholder="Phone number"
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(e.target.value);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    label="House number, Unit number"
                                    placeholder="House number, Unit number"
                                    onChange={(e) => setAddress(e.target.value)}
                                    value={address}
                                    variant="outlined"
                                    color="primary"
                                    error={form && IsNullOrEmpty(address)}
                                    helperText={
                                        form && IsNullOrEmpty(address)
                                            ? "Address is required"
                                            : ""
                                    }
                                    className="mb-4"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    label="Block/road"
                                    placeholder="Block/road"
                                    onChange={(e) =>
                                        setAddress1(e.target.value)
                                    }
                                    value={address1}
                                    variant="outlined"
                                    color="primary"
                                    error={form && IsNullOrEmpty(address1)}
                                    helperText={
                                        form && IsNullOrEmpty(address1)
                                            ? "Address1 is required"
                                            : ""
                                    }
                                    className="mb-4"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    label="Postcode"
                                    placeholder="Postcode"
                                    onChange={(e) =>
                                        setPostCode(e.target.value)
                                    }
                                    onBlur={(e) => {
                                        fetch(
                                            `https://maps.googleapis.com/maps/api/geocode/json?components=country:${getCountryByCode(
                                                countryCode
                                            )}|postal_code:${postCode}&key=${api_key}`
                                        )
                                            .then((response) => response.json())
                                            .then(function (response) {
                                                //parse the response for a list of matching city/state
                                                var possibleLocalities =
                                                    geocodeResponseToCityState(
                                                        response
                                                    );
                                                if (
                                                    possibleLocalities.length ===
                                                    0
                                                ) {
                                                    setPostCode("");
                                                    setStates([]);
                                                    setCities([]);
                                                } else {
                                                    let dat =
                                                        possibleLocalities.map(
                                                            (x) => {
                                                                return x.city
                                                                    ? x.city
                                                                    : x.state;
                                                            }
                                                        );
                                                    setCities(_.uniq(dat));

                                                    dat =
                                                        possibleLocalities.map(
                                                            (x) => {
                                                                return x.state
                                                                    ? x.state
                                                                    : x.city;
                                                            }
                                                        );
                                                    setStates(_.uniq(dat));
                                                }
                                            });
                                    }}
                                    value={postCode}
                                    variant="outlined"
                                    color="primary"
                                    error={form && IsNullOrEmpty(postCode)}
                                    helperText={
                                        form && IsNullOrEmpty(postCode)
                                            ? "Postcode is required"
                                            : ""
                                    }
                                    className="mb-4"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel id="demo-simple-select-outlined-label">
                                        City/ Town
                                    </InputLabel>
                                    <Select
                                        variant="outlined"
                                        fullWidth
                                        className="mb-4"
                                        label="City/ Town"
                                        placeholder="City/ Town"
                                        onChange={(e) =>
                                            setCity(e.target.value)
                                        }
                                        value={city}
                                        color="primary"
                                        error={form && IsNullOrEmpty(city)}
                                        helperText={
                                            form && IsNullOrEmpty(city)
                                                ? "City is required"
                                                : ""
                                        }
                                    >
                                        {cities.map((x) => {
                                            return (
                                                <MenuItem key={x} value={x}>
                                                    {x}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel id="demo-simple-select-outlined-label">
                                        State/ Region
                                    </InputLabel>
                                    <Select
                                        className="mb-4"
                                        fullWidth
                                        label="State/region"
                                        placeholder="State/region"
                                        onChange={(e) =>
                                            setCurState(e.target.value)
                                        }
                                        value={state}
                                        variant="outlined"
                                        color="primary"
                                        error={form && IsNullOrEmpty(state)}
                                        helperText={
                                            form && IsNullOrEmpty(state)
                                                ? "State is required"
                                                : ""
                                        }
                                    >
                                        {states.map((x) => {
                                            return (
                                                <MenuItem key={x} value={x}>
                                                    {x}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    placeholder="Email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    variant="outlined"
                                    color="primary"
                                    helperText={
                                        form &&
                                        (IsNullOrEmpty(email) ||
                                            !validEmail(email))
                                            ? "Email Should be valid and not empty"
                                            : ""
                                    }
                                    error={
                                        form &&
                                        (IsNullOrEmpty(email) ||
                                            !validEmail(email))
                                    }
                                    className="mb-4"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    label="Save as"
                                    placeholder="Save as"
                                    onChange={(e) =>
                                        setNickName(e.target.value)
                                    }
                                    value={nickName}
                                    variant="outlined"
                                    color="primary"
                                    className="mb-4"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <div className="delivery-add mb-2">
                                    <div className="flex items-center justify-between">
                                        <span
                                            style={{
                                                fontWeight:
                                                    isDefault === true
                                                        ? 700
                                                        : 400,
                                            }}
                                        >
                                            Default receiver address
                                        </span>
                                        <span>
                                            <input
                                                className="checkbox"
                                                disabled={
                                                    isDefaultExist.length === 0
                                                }
                                                type="checkbox"
                                                checked={
                                                    isDefaultExist.length === 0
                                                        ? true
                                                        : isDefault === true
                                                }
                                                onClick={(e) =>
                                                    setIsDefault(
                                                        e.target.checked
                                                    )
                                                }
                                            />
                                        </span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <span
                                            style={{
                                                fontWeight:
                                                    isSeller === true
                                                        ? 700
                                                        : 400,
                                            }}
                                        >
                                            Default sender address
                                        </span>
                                        <span>
                                            <input
                                                className="checkbox"
                                                type="checkbox"
                                                disabled={
                                                    isSellerExist.length === 0
                                                }
                                                checked={
                                                    isSellerExist.length === 0
                                                        ? true
                                                        : isSeller === true
                                                }
                                                onClick={(e) => {
                                                    setIsSeller(
                                                        e.target.checked
                                                    );
                                                }}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </DialogContent>
                <DialogActions>
                    <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        onClick={() => setShowModal(false)}
                        className="btn btn-disabled btn-small"
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className="btn btn-blue-new btn-small"
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Address;
